import { IAssociationFormResponse, IAssociationFormData } from "./types";
import { ApiResponse, AssociationModel } from "../types";
import { getApiBaseUrl } from "../utils";
import { api } from "../api";

const API_ENDPOINT = `${getApiBaseUrl()}/api/v1/association`;

export const getAssociationDetails = async (associationId: string | number): Promise<AssociationModel | null> => {
  let data: AssociationModel | null = null;
  try {
    const res = await api<AssociationModel | null>(`${API_ENDPOINT}/${associationId}`, {
      headers: {
        Accept: "application/json",
      },
      credentials: "include",
    });
    if (res.ok) {
      data = res.data || null;
    }
  } catch (e) {
    console.error("getAssociationDetails error:", e);
  }
  return data;
};

export const triggerAssociationAiReview = async (
  associationId: string | number
): Promise<ApiResponse<AssociationModel>> => {
  return await api<AssociationModel>(`${API_ENDPOINT}/${associationId}/trigger-ai-review`, {
    method: "POST",
    headers: {
      Accept: "application/json",
    },
    credentials: "include",
  });
};

export const patchAssociationDetails = async (
  id: number | string,
  data: IAssociationFormData
): Promise<ApiResponse<IAssociationFormResponse>> => {
  return await api<AssociationModel>(`${API_ENDPOINT}/${id}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    credentials: "include",
    body: JSON.stringify({
      ...data,
      _method: "patch",
    }),
  });
};

export const patchAssociationDetailsMedia = async (
  id: number | string,
  data: IAssociationFormData
): Promise<ApiResponse<IAssociationFormResponse>> => {
  const formData = new FormData();
  Object.entries(data).forEach(([key, value]) => {
    formData.append(key, value as string | File);
  });
  formData.append("_method", "patch");

  return await api<IAssociationFormResponse>(`${API_ENDPOINT}/${id}`, {
    method: "POST",
    headers: {
      Accept: "application/json",
    },
    credentials: "include",
    body: formData,
  });
};
